import { createClient, SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

// Graceful fallback: create a placeholder client when env vars are missing.
// Auth features won't work, but the app won't crash on startup.
let supabase: SupabaseClient;

if (supabaseUrl && supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: "foreclosure-auth",
    },
  });
} else {
  // eslint-disable-next-line no-console
  console.warn(
    "Supabase env vars missing. Auth features disabled. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in frontend/.env"
  );
  // Create a dummy client pointing to a placeholder URL — auth calls will fail
  // gracefully but the app renders and browse features work.
  supabase = createClient("https://placeholder.supabase.co", "placeholder", {
    auth: { persistSession: false, autoRefreshToken: false },
  });
}

export { supabase };
